import { ComponentType } from 'components/SalaryComponents/types';

export const SalaryStructureComponentValueTypeLabels = {
  SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_CTC: {
    label: 'Percentage',
  },
  SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_FIXED: {
    label: 'Yearly amount',
  },
};

export const predefinedComponentTypes: ComponentType[] = [
  'COMPONENT_TYPE_BASIC',
  'COMPONENT_TYPE_SPECIAL_ALLOWANCE',
  'COMPONENT_TYPE_DA',
  'COMPONENT_TYPE_HRA',
  'COMPONENT_TYPE_LTA',
];

export const deletablePredfinedComponentTypes: ComponentType[] = [
  'COMPONENT_TYPE_DA',
  'COMPONENT_TYPE_HRA',
  'COMPONENT_TYPE_LTA',
];

export const nonDeletablePredfinedComponentTypes: ComponentType[] = [
  'COMPONENT_TYPE_BASIC',
  'COMPONENT_TYPE_SPECIAL_ALLOWANCE',
];